module.exports = __webpack_public_path__ + "static/media/firefox.8bf2169b.svg";